/*
 * Copyright (c) 2020, TIV.NET INC. All Rights Reserved.
 */

const go = ($) => {

	/**
	 * Extend the SelectMenu widget.
	 * https://learn.jquery.com/jquery-ui/widget-factory/extending-widgets/
	 */
	$.widget("custom.iconSelectMenu", $.ui.selectmenu, {

		/**
		 * Add flag to the Button.
		 * Button is what we see when the dropdown is closed: the currently selected element.
		 */
		_drawButton: function () {
			/*
			* <span tabindex="0" id="ui-id-1-button" ...>
			* <span class="ui-selectmenu-icon ui-icon ui-icon-triangle-1-s"></span>
			* <span class="ui-selectmenu-text">AUD: Australian dollar (AU$)</span>
			* </span>
			*
			* We want flag before the "ui-selectmenu-text" <span>.
			*/
			let $item, $buttonItem, selectedValue;

			// Let the parent widget render.
			this._super();

			if (this._parseOption) {
				// jQuery-UI 1.12
				// Use a code snippet from the parent method to find the selected option value.
				$item = this._parseOption(
					this.element.find("option:selected"),
					this.element[0].selectedIndex
				);
				$buttonItem = this.buttonItem;
			} else {
				// jQuery-UI 1.11
				$item = this.element.find("option:selected")[0];
				$buttonItem = this.button.find(".ui-selectmenu-text");
			}

			selectedValue = $item.value;

			// buttonItem is the <span class="ui-selectmenu-text"> element. Adding flag.
			$("<span>", {"class": "currency-flag currency-flag-" + selectedValue.toLowerCase()}).prependTo($buttonItem);
		},

		/**
		 * Set wrapping CSS class.
		 * @link https://api.jqueryui.com/selectmenu/#method-_renderMenu
		 * @since 2.4.1
		 * @param ul The list element.
		 * @param items The list items.
		 * @private
		 */
		_renderMenu: function (ul, items) {
			this._super(ul, items);
			$(ul).parent().addClass('woocommerce-currency-selector-dropdown');
		},

		/**
		 * Add the flags CSS to each Item.
		 * Items are the dropdown list elements.
		 */
		_renderItem: function (ul, item) {

			/*
			 * We should get this:
			 *
			 *     <li class="ui-menu-item">
			 *         <div class="woocommerce-currency-selector-option ...">
			 *             <span class="currency-flag currency-flag-aud"></span>AUD: Australian dollar (AU$)
			 *         </div>
			 *     </li>
			 *
			 */

			// Let the parent widget generate the <li> element.
			let $li = this._super(ul, item);
			// Find the "wrapper" <div> inside the <li>.
			let $wrapper = $li.find("div")

			if (!$wrapper.length) {
				// jQuery-UI 1.11 did not have the wrapper. Add it and re-find.
				$li.wrapInner($("<div>"));
				$wrapper = $li.find("div")
			}

			// Add our class to the wrapper.
			$wrapper.addClass("woocommerce-currency-selector-option");

			// Prepend the "flag" <span> to the text inside the wrapper.
			$("<span>", {"class": "currency-flag currency-flag-" + item.value.toLowerCase()}).prependTo($wrapper);

			return $li;
		},

		/**
		 * Adjust Button width.
		 * Button is what we see when the dropdown is closed: the currently selected element.
		 */
		_resizeButton: function () {
			this._super();
			// Increase width to fit the flag
			let width = this.button.outerWidth();
			this.button.outerWidth(width + 18);
		}

	});
};

module.exports = {
	go
};
